// Web-only strings for the search feature (keys prefixed `web.search.`), BOTH languages. Everything
// the Apple screen already says comes from its keys (`search.*`, Strings.Search).
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.search.start.title': 'Busca en tus mensajes',
    'web.search.start.body': 'Escribe una palabra o una "frase entre comillas" y pulsa Intro. Los filtros de arriba acotan por persona, canal o fecha.',
    'web.search.searchingServer': 'Buscando en el servidor…',
    'web.search.clearRecents': 'Borrar todo',
    'web.search.removeRecent': 'Quitar de las búsquedas recientes',
    'web.search.inThread': 'En un hilo',
    'web.search.more': 'Más resultados',
    'web.search.modifiersLabel': 'Filtros de búsqueda',
    'web.search.modifier.from': 'persona',
    'web.search.modifier.in': 'canal',
    'web.search.modifier.before': 'antes de',
    'web.search.modifier.after': 'después de',
    'web.search.modifier.on': 'el día',
    'web.search.modifier.from.hint': 'Mensajes de una persona — from:ana.torres',
    'web.search.modifier.in.hint': 'Mensajes de un canal o conversación — in:anuncios, in:@ana.torres',
    'web.search.modifier.before.hint': 'Antes de un día (sin incluirlo) — before:2026-08-20',
    'web.search.modifier.after.hint': 'Después de un día (sin incluirlo) — after:2026-08-20',
    'web.search.modifier.on.hint': 'Un día concreto — on:2026-08-20',
  },
  en: {
    'web.search.start.title': 'Search your messages',
    'web.search.start.body': 'Type a word or a "quoted phrase" and press Return. The filters above narrow it by person, channel or date.',
    'web.search.searchingServer': 'Searching the server…',
    'web.search.clearRecents': 'Clear all',
    'web.search.removeRecent': 'Remove from recent searches',
    'web.search.inThread': 'In a thread',
    'web.search.more': 'More results',
    'web.search.modifiersLabel': 'Search filters',
    'web.search.modifier.from': 'person',
    'web.search.modifier.in': 'channel',
    'web.search.modifier.before': 'before',
    'web.search.modifier.after': 'after',
    'web.search.modifier.on': 'on day',
    'web.search.modifier.from.hint': 'Messages from a person — from:ana.torres',
    'web.search.modifier.in.hint': 'Messages in a channel or conversation — in:announcements, in:@ana.torres',
    'web.search.modifier.before.hint': 'Before a day (not including it) — before:2026-08-20',
    'web.search.modifier.after.hint': 'After a day (not including it) — after:2026-08-20',
    'web.search.modifier.on.hint': 'A specific day — on:2026-08-20',
  },
};
